document.addEventListener('DOMContentLoaded', function () {
  (window.mm01Config || []).forEach(function (cfg) {
    var root = document.getElementById('mm01-' + cfg.sectionId);
    if (!root) return;

    // ---- Thumbnail gallery ----
    var mainImg = document.getElementById('mm01-img-0-' + cfg.sectionId);
    root.querySelectorAll('.mm01-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.mm01-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      });
    });

    // ---- Accordion ----
    root.querySelectorAll('.mm01-acc-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mm01-acc-item');
        var wasOpen = item.classList.contains('open');
        root.querySelectorAll('.mm01-acc-item').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });

    // ---- Variant selection (updates hidden variant id + price on chip click) ----
    var selectedOptions = [];
    (cfg.optionNames || []).forEach(function () { selectedOptions.push(null); });

    root.querySelectorAll('.mm01-chip').forEach(function (chip) {
      var idx = parseInt(chip.dataset.optionIndex, 10);
      if (chip.classList.contains('selected')) selectedOptions[idx] = chip.dataset.value;

      chip.addEventListener('click', function () {
        var group = chip.closest('.mm01-variant-block');
        group.querySelectorAll('.mm01-chip').forEach(function (c) { c.classList.remove('selected'); });
        chip.classList.add('selected');
        selectedOptions[idx] = chip.dataset.value;

        var selLabel = document.getElementById('mm01-optsel-' + idx + '-' + cfg.sectionId);
        if (selLabel) selLabel.textContent = chip.dataset.value;

        var match = (cfg.variants || []).find(function (v) {
          return selectedOptions.every(function (val, i) {
            return val === null || v['option' + (i + 1)] === val;
          });
        });

        if (match) {
          var hiddenInput = document.getElementById('mm01-variant-id-' + cfg.sectionId);
          if (hiddenInput) hiddenInput.value = match.id;

          var priceEl = document.getElementById('mm01-price-' + cfg.sectionId);
          if (priceEl) priceEl.textContent = formatMoney(match.price);

          var compareEl = document.getElementById('mm01-compare-' + cfg.sectionId);
          var saveEl = document.getElementById('mm01-save-' + cfg.sectionId);
          if (match.compare_at_price && match.compare_at_price > match.price) {
            if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.style.display = ''; }
            if (saveEl) {
              var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
              saveEl.textContent = 'SAVE ' + pct + '%';
              saveEl.style.display = '';
            }
          } else {
            if (compareEl) compareEl.style.display = 'none';
            if (saveEl) saveEl.style.display = 'none';
          }
        }
      });
    });

    function formatMoney(cents) {
      // Simple USD formatter. Swap for Shopify.formatMoney(cents, format)
      // if your theme already loads shopify_common.js with a money format.
      return '$' + (cents / 100).toFixed(2);
    }

    // ---- Ships Today, real clock check against America/Chicago 12:00-17:00 ----
    var badge = document.getElementById('mm01-shipsBadge-' + cfg.sectionId);
    var text = document.getElementById('mm01-shipsText-' + cfg.sectionId);
    if (badge && text) {
      function updateShipsBadge() {
        var now = new Date();
        var chicagoHour = parseInt(
          new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', hour: 'numeric', hour12: false }).format(now)
        );
        var isWindow = chicagoHour >= 12 && chicagoHour < 17;
        if (isWindow) {
          badge.classList.remove('closed');
          text.textContent = 'Order in the next few hours, ships today';
        } else {
          badge.classList.add('closed');
          text.textContent = 'Ships next business day';
        }
      }
      updateShipsBadge();
      setInterval(updateShipsBadge, 60000);
    }
  });
});
